import React from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'
import styles from './PicTxt.module.scss'

const PicTxt = ({ pic, caption }) => (
    <div className={`${styles.picTxt} row`}>
        <div className="colHalfLg">
            <img alt="UCX urbancoolx" src={pic} />
        </div>
        <div className={`${styles.txt} colHalfLg`}>
            <p className={styles.captionTxt}>{parse(caption)}</p>
        </div>
    </div>
)

PicTxt.propTypes = {
    pic: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired,
}

export default PicTxt
